<!-- Sin recordatorios ni servicios no se renderiza nada: el nodo del odómetro
     solo ya lo cubre la tarjeta "Viaje en Curso". Tampoco durante la carga,
     para no mostrar una card que después desaparece. -->
@if (hayDatos()) {
  <app-content-card
    title="Historial"
    icon="timeline"
    color="purple"
    [showShadow]="true"
    height="100%"
  >
    <!-- Fijos en el header: no scrollean con el contenido -->
    <div card-header-actions class="historial-acciones">
      <button
        irxBotonIcono
        type="button"
        tooltip="Ir al inicio"
        (click)="irArriba()"
      >
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button
        irxBotonIcono
        type="button"
        tooltip="Buscar por km o fecha"
        [activo]="mostrarBuscador()"
        (click)="toggleBuscador()"
      >
        <mat-icon>{{ mostrarBuscador() ? 'search_off' : 'search' }}</mat-icon>
      </button>
      <button
        irxBotonIcono
        type="button"
        tooltip="Ir al final"
        (click)="irAbajo()"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>

    @if (loading()) {
      <app-loading text="Cargando historial..."></app-loading>
    } @else {
      @if (mostrarBuscador()) {
        <div class="historial-buscador">
          <irx-segmentado
            [value]="modoBusqueda()"
            (change)="modoBusqueda.set($event.value)"
          >
            <irx-segmento value="km">Kilómetro</irx-segmento>
            <irx-segmento value="fecha">Fecha</irx-segmento>
          </irx-segmentado>

          @if (modoBusqueda() === 'km') {
            <div class="historial-buscador-fila">
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Kilómetro</mat-label>
                <input
                  matInput
                  type="number"
                  [ngModel]="kmBuscado()"
                  (ngModelChange)="kmBuscado.set($event)"
                  (keyup.enter)="buscarPorKm()"
                />
              </mat-form-field>
              <button irxBoton="secundario" type="button" (click)="buscarPorKm()">
                Ir
              </button>
            </div>
          } @else {
            <app-date-picker
              mode="date"
              label="Fecha"
              [ngModel]="fechaBuscada()"
              (ngModelChange)="buscarPorFecha($event)"
            ></app-date-picker>
          }
          <span class="historial-buscador-hint">
            Salta al ítem más próximo al valor elegido.
          </span>
        </div>
      }

      <div class="historial-scroll" #scroll>
        <div class="historial-timeline">
          @for (item of items(); track $index) {
            <div
              class="historial-item"
              [class.destacado]="item.clase === 'presente'"
            >
              <div class="historial-riel">
                <span
                  class="historial-linea arriba"
                  [class.oculta]="$first"
                ></span>
                <span class="historial-nodo" [ngClass]="item.clase">
                  <mat-icon>{{ item.icono }}</mat-icon>
                </span>
                <span
                  class="historial-linea abajo"
                  [class.oculta]="$last"
                ></span>
              </div>
              <div class="historial-contenido">
                <div class="historial-fila">
                  <span class="historial-titulo">{{ item.titulo }}</span>
                  @if (item.valor) {
                    <span class="historial-valor" [ngClass]="item.clase">
                      {{ item.valor }}
                    </span>
                  }
                </div>
                @if (item.detalle) {
                  <span class="historial-detalle">{{ item.detalle }}</span>
                }
              </div>
            </div>
          }
          @if (sinServicios()) {
            <p class="historial-vacio">Sin cargas ni servicios registrados</p>
          }
        </div>
      </div>
    }
  </app-content-card>
}
